import { render } from "./AddEditProject.vue?vue&type=template&id=9a7163c2&scoped=true"
import script from "./AddEditProject.vue?vue&type=script&lang=js"
export * from "./AddEditProject.vue?vue&type=script&lang=js"

import "./AddEditProject.vue?vue&type=style&index=0&id=9a7163c2&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7163c2"]])

export default __exports__